var translation = {
	Navatar: {
		header: "AWS 設定檔",
		subheader: "您的設定檔有助於改善您與特定 AWS 體驗的互動。",
		profileButtonText: "檢視設定檔",
		logOutText: "登出",
		logInText: "登入",
		createProfileText: "建立個人資料",
		federateLoginModalTitle: "使用 Midway 存取您的 AWS 設定檔",
		federateLoginModalFirstDescription: "對於 Amazon 員工，建議您使用 Midway 存取 AWS 設定檔。此安全性建議方法可與內部系統無縫整合。",
		federateLoginModalSecondDescription: "您會看到此訊息是因為您使用 AWS 建構家 ID 經由 Amazon 電子郵件地址登入。您每次登入時都會出現此提示，直到切換到 Midway，或選擇繼續使用目前的登入。",
		federateLoginModalPrimaryButton: "使用 Midway 登入",
		federateLoginModalSecondaryButton: "繼續使用 AWS 建構家 ID"
	}
};
var Navatar = {
	translation: translation
};

export { Navatar as default, translation };
